import React, { useEffect, useState } from 'react';
//horizontalScroll
import ScrollContainer from 'react-indiana-drag-scroll';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
//import styles from 'src/asset/scss/style/mypage.module.scss'
import styles from 'src/asset/scss/style/user.mypage.module.scss';
//hook
import useMyPageHook from 'src/webapp/hooks/mypage/mypage.hook';
//store
import usePartnerStore from 'src/webapp/stores/partner.store';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import SubTitleBar from 'src/webapp/views/component/title/SubTitleBar';//서브타이틀
import BizTimeUpdate from 'src/webapp/views/user/mypage/bottomsheet/BsBizTimeUpdate';

export default function BizTimeList() {
    const { axiosPostHandler } = useAxiosHook();//axios
    const { isState, partner } = usePartnerStore();//store
    const { isOpen, handleDismissChange } = useMyPageHook();//수정오픈useState, 수정팝업off핸들러

    /* =============== 영업시간리스트 =============== */
    const [bizDayList, setBizDayList] = useState([]);
    const bizDayListAPI = async () => {
        const DATA = { PARTNER_CD: partner.COMN_CD };
        const result = await axiosPostHandler(`partnerBizDayListForPartner.do`, DATA);
        if(!result || result.message !== "SUCCESS" ) { return; }
        if(result.message === "SUCCESS") { setBizDayList(result.data); }
    }
    useEffect(() => {
        if(!isState) { return; }

        bizDayListAPI();
    }, [isState])
    /* =============== 영업시간리스트 =============== */

    return (
        <>
        <Element tag={`div`} className={styles.bizDayContainer}>
            <SubTitleBar title={`영업시간`}>
                <button onClick={(e) => handleDismissChange(true)}><FontAwesomeIcon icon="fa-light fa-pen-line" /><Element tag={`span`}>수정하기</Element></button>
            </SubTitleBar>
            {bizDayList.length > 0 ?
                <ScrollContainer horizontal={true} component={`ul`}>
                    {bizDayList.map((item) => 
                        <Element tag={`li`}>
                            <Element tag={`small`}>{item.DAYS === item.TODAY ? <Element tag={`span`}>오늘</Element> : null}</Element>
                            <Element tag={`h1`}>{item.DAYS_STR}</Element>
                            <Element tag={`div`}>영업시간 <Element tag={`label`}>{item.BIZ_TIME}</Element></Element>
                            {item.BREAK_TIME !== undefined && item.BREAK_TIME !== null ? <Element tag={`div`}>휴게시간 <Element tag={`label`}>{item.BREAK_TIME.replaceAll(`브레이크타임`, '')}</Element></Element> : null}
                        </Element>
                    )}
                </ScrollContainer>
            : null}
        </Element>
        
        {isOpen ? <BizTimeUpdate isOpen={isOpen} bizDayListAPI={bizDayListAPI} onDismiss={handleDismissChange} /> : null}
        </>
    );
}